import React ,{useEffect} from "react";
import "./ContactUs.css";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Link } from "react-router-dom";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="container-fluid" id="contact-us-page">
      <div className="row first-row">
        <h3>Contact Us</h3>
        <p>
          For inquiries, collaborations, or to explore how our automation
          solutions can elevate your operations, please reach out to Unique
          Technologies. We're here to assist you in achieving efficiency,
          reliability, and sustainability in your processes.
        </p>
      </div>
      <div className="row second-row">
        <div className="col">
        <LocationOnIcon/>
        <br />
        <p><b>Office:</b> B-102,Sector-64,Noida,U.P.- 201301</p><br />
        </div>
        <div className="col">
        <LocationOnIcon/>
        <br />
            <p><b>Factory:</b>Plot no. 29, MUP 1, Ecotech 3, Gautam Budh Nagar, Greater Noida-201306 (U.P.).</p></div>
        <div className="col">
        <EmailIcon/>
        <br />
        <p>d.pandey@uniqutechnologies.com</p>
        </div>
        <Link className="col" style={{textDecoration:"none"}} to="tel:9999044355">
        <LocalPhoneIcon/>
        <br />
        <p ><div >Tap to make a call <br /> +91 99990 44355 </div></p>
        </Link>
      </div>

      <div className="row third-row map-row">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.5956580902875!2d77.37562747475083!3d28.61190458501848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef0ce2704c6f%3A0x237413018af1ebbc!2sUnique%20Technologies!5e0!3m2!1sen!2sin!4v1708945644780!5m2!1sen!2sin"
          width="600"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="row fourth-row">
        <div className="col left-col">
         <form action="https://formspree.io/f/xvoeryqk"
  method="POST">
          <input type="text" name="full name" required placeholder="Your Name" />
          <input  type="number" onInput={(e) => e.target.value = e.target.value.slice(0, 10)} name="phone" required placeholder="Your 10 digit mobile number" />
          <input type="email" name="email" required placeholder="Enter Your Email" />
          <input type="text" name="subject" required placeholder="Subjet" />
          <textarea name="message" id="" required cols="30" rows="5"></textarea>
          <button type="submit">SUBMIT</button>
         </form>
      
        </div>
        <div className="col right-col">
          <h1>Contact</h1>
          <h1>____Us</h1>
          <h2>Send Your Message</h2>
          
          <p>Need assistance? Contact us via email or phone. We're here to help with any questions, concerns, or feedback you may have..</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
